import { createContextWithRoot } from '@patternfly/pfe-core/functions/context.js';
export const context = createContextWithRoot(Symbol('rh-accordion-context'));
//# sourceMappingURL=context.js.map